import { ALPHA__Drawer as Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/ALPHA/Drawer";
import { categoriseMessages } from "../../utils";
import styles from "./SpecialOffersDrawer.module.scss";
import SpecialOffersDrawerPromotion from "../SpecialOffersPromotion/SpecialOffersPromotion";
import {
  NonPromotionalMessage,
  PromotionalMessage,
} from "../../../../types/prodcatBaseTypes";
import { SaleTagIcon } from "../../../__shared__/SaleTagIcon/SaleTagIcon";

type SpecialOffersDrawerProps = {
  /**
   * An array of Message objects.
   */
  promotions: (NonPromotionalMessage | PromotionalMessage)[];
  drawerIsOpen: boolean;
  onClose: () => void;
  onPromotionClose: () => void;
  isNewPromoDrawer: boolean;
};

export const SpecialOffersDrawer = ({
  promotions,
  drawerIsOpen,
  onClose,
  onPromotionClose,
  isNewPromoDrawer,
}: SpecialOffersDrawerProps) => {
  if (isNewPromoDrawer) {
    const messagesWithCategoryAndType = categoriseMessages(promotions);

    const offers = messagesWithCategoryAndType.filter(
      (message) => message.category === "offers",
    );
    const services = messagesWithCategoryAndType.filter(
      (message) => message.category === "services",
    );
    const claims = messagesWithCategoryAndType.filter(
      (message) => message.category === "claims",
    );
    return (
      <Drawer
        isOpen={drawerIsOpen}
        onClose={onClose}
        isDrawerLeft={false}
        isHeaderFixed={true}
        isNarrow={false}
        rootId="page-root"
        isOffersDrawer
        headerStyleModifier={styles.drawerHeader}
      >
        {offers.length > 0 && (
          <section className={styles.categorySection}>
            <div className={styles.titleSection}>
              <div className={styles.title}>
                <SaleTagIcon size="medium" />
                <h2>Offers</h2>
              </div>
              <p>Select one offer to use now at checkout.</p>
            </div>
            {offers.map((promotion, index) => (
              <SpecialOffersDrawerPromotion
                key={index}
                promotion={promotion}
                drawerIsOpen={drawerIsOpen}
                onClose={onPromotionClose}
                isNewPromoDrawer={true}
              />
            ))}
          </section>
        )}
        {services.length > 0 && (
          <section className={styles.categorySection}>
            <div className={styles.titleSection}>
              <div className={styles.title}>
                <SaleTagIcon size="medium" />
                <h2>Service offers</h2>
              </div>
              <p>
                Add to your basket without a promo code. Works alongside any
                offers.
              </p>
            </div>
            {services.map((promotion, index) => (
              <SpecialOffersDrawerPromotion
                key={index}
                promotion={promotion}
                drawerIsOpen={drawerIsOpen}
                onClose={onPromotionClose}
                isNewPromoDrawer={true}
              />
            ))}
          </section>
        )}
        {claims.length > 0 && (
          <section className={styles.categorySection}>
            <div className={styles.titleSection}>
              <div className={styles.title}>
                <h2>Claims</h2>
              </div>
              <p>After purchase, claim any of these back.</p>
            </div>
            {claims.map((promotion, index) => (
              <SpecialOffersDrawerPromotion
                key={index}
                promotion={promotion}
                drawerIsOpen={drawerIsOpen}
                onClose={onPromotionClose}
                isNewPromoDrawer={true}
              />
            ))}
          </section>
        )}
      </Drawer>
    );
  } else {
    return (
      <Drawer
        isOpen={drawerIsOpen}
        onClose={onClose}
        header={
          promotions.length === 1
            ? "Special offer"
            : `Special offers (${promotions.length})`
        }
        isDrawerLeft={false}
        isHeaderFixed={true}
        isNarrow={false}
        rootId="page-root"
        isOffersDrawer
        className={styles.redPromoDrawer}
      >
        {promotions.map((promotion, index) => (
          <SpecialOffersDrawerPromotion
            key={index}
            promotion={promotion}
            drawerIsOpen={drawerIsOpen}
            onClose={onPromotionClose}
            isNewPromoDrawer={false}
          />
        ))}
      </Drawer>
    );
  }
};
